import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import apiService from "../APIService";
import chatPerson from "../../images/img/chat-person.png";
import deliveryTimeIcon from "../../images/img/deliverytime-icon.svg";
import Banner from "../FormFields/Banner";
import MessageA1 from "./MessageCodes/MessageA1";
import MessageA2 from "./MessageCodes/MessageA2";
import MessageA3 from "./MessageCodes/MessageA3";
import MessageRedirect from "./MessageCodes/MessageRedirect";
import MessageA5 from "./MessageCodes/MessageA5";
import MessageA13 from "./MessageCodes/MessageA13";
import MessageA14 from "./MessageCodes/MessageA14";
import MessageA15 from "./MessageCodes/MessageA15";
import "../HelpAssistant/HelpAssistant.css";
import MessageA39 from "./MessageCodes/MessageA39";
import MessageA17 from "./MessageCodes/MessageA17";
import MessageA22 from "./MessageCodes/MessageA22";
import MessageA24 from "./MessageCodes/MessageA24";
import RechargeToast from "../RechargeToast";
import MessageA19 from "./MessageCodes/MessageA19";
import MessageA23 from "./MessageCodes/MessageA23";
import MessageA42 from "./MessageCodes/MessageA42";
import MessageA6 from "./MessageCodes/MessageA6";
import MessageA7 from "./MessageCodes/MessageA7";
import MessageA21 from "./MessageCodes/MessageA21";
import moment from "moment";
import MessageA48 from "./MessageCodes/MessageA48";
import MessageA58 from "./MessageCodes/MessageA58";
import MessageA59 from "./MessageCodes/MessageA59";
import MessageA60 from "./MessageCodes/MessageA60";
import MessageA61 from "./MessageCodes/MessageA61";
import MessageA62 from "./MessageCodes/MessageA62";
import FilterConfirmation from "../FormFields/FilterConfirmationComponent/FilterConfirmation";
import userIcon from "../../../src/images/img/user.svg";
import MessageA80 from "./MessageCodes/MessageA80";
//import ClipLoader from "react-spinners/ClipLoader";

const Conversation = (props) => {
  // console.log("converstaionprops", props, props.sth, props.showHistory)

  const [currentData, setCurrentData] = useState([]);
  const timeCurrent =
    new Date().toLocaleTimeString("en-us").split(":")[0] +
    ":" +
    new Date().toLocaleTimeString("en-us").split(":")[1] +
    " " +
    new Date().toLocaleTimeString("en-us").substr(-2);
  const [messages, setMessages] = useState([]);
  const [initalState, setInitalState] = useState([]);
  const [textOnClick, setTextOnClick] = useState();
  const [inputValue, setInputValue] = useState();
  const [showBanner, setShowBanner] = useState(false);
  const [bannerData, setBannerData] = useState();
  const [showRecharge, setShowRecharge] = useState(false);
  const [rechargeData, setRechargeData] = useState();
  const [historyData, setHistoryData] = useState();
  const [showHistory, setShowHistory] = useState(props.showHistory);
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [historyFirstData, setHistoryFirstData] = useState([]);
  const [auth, setAuth] = useState(props.auth);
  const [textMessage, setTextMessage] = useState(props.textMessage);
  const [enableTextBox, setEnableTextBox] = useState(false);

  const [dateSelect, setDateSelect] = useState();

  const messagesEndRef = useRef(null);

  window.s360BannerCallback = (code) => {
    // console.log("bannercallbackcode", code);
    handleClick(code);
    if (code === "1.6.1.1.1.12.13.17") setTextOnClick("Register Now");
    else if (code === "1.6.1.1.1.12.13.17.1.1") setTextOnClick("Done");
  };
  // useEffect(() => {
  //   // alert("reached in conversation")
  //   //  console.log(props.action ,props.outSideLink,localStorage.getItem("linkChatOnce"),"check here")
  //   if (
  //     (props.action || props.outSideLink) &&
  //     localStorage.getItem("linkChatOnce") === null &&
  //     localStorage.getItem("linkLoginOnce") === null
  //   ) {
  //     sendOutsideLinkApi();
  //   }
  // }, []);
  // console.log("action from config in CONVERSATION.JS",props.action)

  useEffect(() => {
    setAuth(props.auth);
  }, [props.auth]);

  useEffect(() => {
    if (currentData?.length === 0) setCurrentData(props.chatData);
  }, [props.chatData]);
  //history api
  useEffect(() => {
    const response =
      props.historyData &&
      props.historyData.history &&
      props.historyData.history.history;
    // console.log("TextBoxEnabled", enableTextBox)

    const inidata =
      response &&
      response[0] &&
      response[0] &&
      response[0].botResponse &&
      response[0].botResponse.entries &&
      response[0].botResponse.entries.map((i) => i);

    inidata &&
      inidata.map(
        (item, index) => item.code && historyFirstData.push(item.code)
      );
    // console.log("firstresponse", inidata, historyFirstData)

    const data =
      response &&
      response.map(
        (res) =>
          res.botResponse &&
          res.botResponse.entries &&
          res.botResponse.entries.map((item, index) => {
            // console.log("res..",res.botResponse.entries)
            return (
              <>
                {item.uiCommand === "A1" && (
                  <MessageA1
                    item={item}
                    handleClick={handleClick}
                    setTextOnClick={setTextOnClick}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A3" && (
                  <MessageA3
                    item={item}
                    index={index}
                    userInputObj={res.userInputObj}
                  />
                )}
                {item.uiCommand === "A2" && (
                  <MessageA58
                    item={item}
                    handleClick={handleClick}
                    setTextOnClick={setTextOnClick}
                    userInputObj={res.userInputObj}
                  />
                )}
                {item.uiCommand === "A6" && (
                  <MessageA6 item={item} userInputObj={res.userInputObj} />
                )}
                {item.uiCommand === "Redirect" && (
                  <MessageRedirect
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A39" && (
                  <MessageA39 item={item} userInputObj={res.userInputObj} />
                )}
                {item.uiCommand === "A14" && (
                  <MessageA14
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A17" && (
                  <MessageA17 item={item} userInputObj={res.userInputObj} />
                )}
                {item.uiCommand === "A5" && (
                  <MessageA5
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A13" && (
                  <MessageA13
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A15" && (
                  <MessageA15
                    item={item}
                    handleClick={handleClick}
                    setTextOnClick={setTextOnClick}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A19" && (
                  <MessageA19 item={item} userInputObj={res.userInputObj} />
                )}
                {item.uiCommand === "A21" && (
                  <MessageA21
                    item={item}
                    handleClick={handleClick}
                    userInputObj={res.userInputObj}
                  />
                )}
                {item.uiCommand === "A22" && (
                  <MessageA22
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A23" && (
                  <MessageA23
                    item={item}
                    handleClick={handleClick}
                    setTextOnClick={setTextOnClick}
                    userInputObj={res.userInputObj}
                  />
                )}
                {item.uiCommand === "A24" && (
                  <MessageA24 item={item} userInputObj={res.userInputObj} />
                )}
                {item.uiCommand === "A42" && (
                  <MessageA42 item={item} userInputObj={res.userInputObj} />
                )}
                {item.uiCommand === "A48" && (
                  <MessageA48
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                  />
                )}
                {item.uiCommand === "A58" && (
                  <MessageA58
                    item={item}
                    userInputObj={res.userInputObj}
                    disable={true}
                    handleClick={handleClick}
                    tag={item.uiCommand}
                  />
                )}
                {index === res.botResponse.entries.length - 1 && (
                  <div style={{ width: "100%" }}>
                    <br />
                    <div className="delivery-time"></div>
                  </div>
                )}
                {index === res.botResponse.entries.length - 1 && (
                  <div className="onclick-openwrapp section0 userchatmsg0_1 userchatmsg">
                    {res.userResponse.text === "" && (
                      <div
                        className="onclick-inner"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <span className="packs-img">
                          {JSON.parse(localStorage.getItem("userName")) !==
                          "Testing" ? (
                            JSON.parse(localStorage.getItem("userName"))
                              ?.match(/\b(\w)/g)
                              .join("")
                          ) : (
                            <img height="15" width="15" src={userIcon}></img>
                          )}
                        </span>{" "}
                        <span className="packs-text">
                          {res.userResponse.text}
                        </span>{" "}
                      </div>
                    )}
                    {res.userResponse.text === "" && (
                      <div>
                        <div
                          className="delivery-time-first"
                          style={{
                            display: "flex",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          {moment(res.createdAt).format("LT")}
                          <span>
                            <img
                              src={deliveryTimeIcon}
                              className="img-fluid"
                              alt=""
                            />
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            );
          })
      );
    setHistoryData([data]);
    setShowHistory(true);
    //  setMessages([...messages,data])
    // console.log("historyDataA", response, data)
  }, [props.historyData]);

  // const sendOutsideLinkApi = () => {
  //   const tempLinkDetails = props.tempLinkDetails;
  //   apiService
  //     .loginForLink(
  //       tempLinkDetails?.subId,
  //       tempLinkDetails.authenticated,
  //       tempLinkDetails.action,
  //       localStorage.getItem("jumpNode")
  //     )
  //     .then((response) => {
  //       console.log(props.tempLinkDetails, "LOGINDETAILS");
  //       localStorage.setItem("token", response.data.token);

  //       if (response.data.userInfo !== undefined) {
  //         localStorage.setItem(
  //           "userName",
  //           JSON.stringify(response?.data?.userInfo?.customerName)
  //         );
  //       } else {
  //         localStorage.setItem("userName", JSON.stringify("Testing"));
  //       }

  //       const n =
  //         response.data &&
  //         response.data.userInfo &&
  //         response.data.userInfo.accountDetails &&
  //         response.data.userInfo.accountDetails.accountDetails &&
  //         response.data.userInfo.accountDetails.accountDetails &&
  //         response.data.userInfo.accountDetails.accountDetails[0] &&
  //         response.data.userInfo.accountDetails.accountDetails[0].fname;
  //       props.setLoginFromProps(true);
  //       //setLogin(true)
  //       // console.log("name",response.data.userInfo.accountDetails.accountDetails[0].fname,n );
  //       if (auth) {
  //         // apiService.refreshChat().then(res => {
  //         //     props.setLoginLoader(false)
  //         //     props.setLogin(true)
  //         //     // console.log("response", response);
  //         // })
  //       } else {
  //         props.setLoginLoader(false);
  //         props.setLogin(true);
  //       }
  //       apiService.chatForLink(response.data.token).then((response) => {
  //         setIsLoading(false);
  //         const data =
  //           response.data &&
  //           response.data.chatResponse &&
  //           response.data.chatResponse.entries;
  //         // console.log(data,'data check')
  //         props.setLoginLoader(false);
  //         setCurrentData(data);

  //         props.setLogin(true);
  //       });
  //     });

  //   //get token from here and inside this only send chat in .then
  //   //remove other chat response
  // };

 
  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };
 //new addition 1
 useEffect(() => {
  
   setCurrentData(props.currentData)
    
  }, [props.currentData]);
 //
  useEffect(() => {
    if (props.login && !props.outSideLink && !props.action) {
      setInitialLoading(true);
      props.handleInputBox(false);
      //CHANGE FOR TEXTBOX
      apiService.initialState().then((response) => {
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        // if(response.data && response.data.chatResponse && response.data.chatResponse.enableDefaultTextBox != null){
        //   console.log("zzz")
        //   // props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);

        // }
        props.handleInputBox(false);
        //CHANGE FOR TEXT BOX
        // console.log("currentData", data)
        setInitialLoading(false);
        data &&
          data.map((i) => {
            if (i.uiCommand === "A41") {
              setShowBanner(true);
              setBannerData(i);
            }
            if (i.uiCommand === "A40") {
              setShowRecharge(true);
              setRechargeData(i);
            }
          });
        setCurrentData(data);
        data &&
          data.map((item, index) => item.code && initalState.push(item.code));
      });
    }
  }, [props.login]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  const enableInputBox = (data) => {
    if (data === true) {
      //disabling textbox temporarily ()
      props.handleInputBox(false);
    } else {
      props.handleInputBox(true);
    }
  };

  useEffect(() => {
    scrollToBottom();

    //  console.log(currentData,"CURRENT DATA")
  }, [currentData, props.sendText]);

  useEffect(() => {
    enableInputBox(enableTextBox);
  }, [enableTextBox]);

  // console.log("conversationData", currentData);

  const handleRefresh = (code) => {
    setIsLoading(true);
    if (auth) {
      apiService.refreshChat().then((response) => {
        // console.log("login response", response, response.data);
        apiService.chat(code).then((response) => {
          setIsLoading(false);
          const data =
            response.data &&
            response.data.chatResponse &&
            response.data.chatResponse.entries;
          setCurrentData(data);
          // setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
          setEnableTextBox(false);
        });
      });
    } else {
      apiService.chat(code).then((response) => {
        // console.log(response,"response")

        setIsLoading(false);
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;
        setCurrentData(data);
        // setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
        setEnableTextBox(false);
      });
    }
  };

  const handleClick = (code, input, tag) => {
    console.log("codeOnClick", code, input, isLoading, tag);

    setIsLoading(true);

    if (initalState.includes(code) && !props.sth) {
      // console.log("FOUND", props.sth);
      handleRefresh(code);
      return;
    } else if (historyFirstData.includes(code) && props.sth) {
      // console.log("FOUND", props.sth);
      handleRefresh(code);
      return;
    }

    if (tag === "A58") {
      //todo add filters to localhost

      apiService.chatPost(code, input).then((response) => {
        // console.log("data response",response.data);

        setIsLoading(false);

        // console.log("currentDataU", response.data,response.data.chatResponse.enableDefaultTextBox);
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        // if(response.data && response.data.chatResponse && response.data.chatResponse.enableDefaultTextBox != null){
        //   props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);
        // }
        // props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);
        // data && data.map(i =>{

        //   if(i.enableDefaultTextBox != null){
        //     // props.handleInputBox(i.enableDefaultTextBox)
        //     if(i.code === 9)
        //     props.handleInputBox(true)

        //   }
        // })

        setCurrentData(data);
        // setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
        setEnableTextBox(false);
        //set filterCode here if needed to opcode
      });
    } else if (tag === "A59") {
      //todo add filters to localhost

      apiService.chatPostPacks(code, input).then((response) => {
        // console.log("data response",response.data);

        setIsLoading(false);

        // console.log("currentDataU", response.data,response.data.chatResponse.enableDefaultTextBox);
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        // if(response.data && response.data.chatResponse && response.data.chatResponse.enableDefaultTextBox != null){
        //   props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);
        // }
        // props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);
        // data && data.map(i =>{

        //   if(i.enableDefaultTextBox != null){
        //     // props.handleInputBox(i.enableDefaultTextBox)
        //     if(i.code === 9)
        //     props.handleInputBox(true)

        //   }
        // })

        setCurrentData(data);
        setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
      });
    } else {
      apiService.chat(code, input).then((response) => {
        setIsLoading(false);

        // console.log("currentDataU", response.data,response.data.chatResponse.enableDefaultTextBox);
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        // if(response.data && response.data.chatResponse && response.data.chatResponse.enableDefaultTextBox != null){
        //   props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);
        // }
        // props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);
        // data && data.map(i =>{

        //   if(i.enableDefaultTextBox != null){
        //     // props.handleInputBox(i.enableDefaultTextBox)
        //     if(i.code === 9)
        //     props.handleInputBox(true)

        //   }
        // })

        setCurrentData(data);
        setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
      });
    }
  };

  useEffect(() => {
    if (props.textMessage.key1) {
      let data = {
        data: "John",
        uiCommand: "A7",
        text: props.textMessage.key1,
      };
      setCurrentData([data]);

      if (props.textMessage.dontSend === undefined) {
        apiService.chat(null, props.textMessage).then((response) => {
          setIsLoading(false);
          const data =
            response.data &&
            response.data.chatResponse &&
            response.data.chatResponse.entries;
          // console.log("daa",response);
          setCurrentData(data);
          // setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
          setEnableTextBox(false);
          // console.log(data[2],"here ")
          var parsedData = null;
          if (data[2] !== undefined && data[2].uiCommand === "A58") {
            parsedData = JSON.parse(JSON.stringify(data[2])).text_data;
            let temp = new Object();
            temp["selectedLanguages"] =
              parsedData?.filter?.language?.selectedLanguages;
            temp["selectedGenre"] = parsedData?.filter?.genre.selectedGenre;

            localStorage.setItem(
              "selectedLanguagesAndGenresTemp",
              JSON.stringify(temp)
            );
          }
        });
      }
    }
    setTextOnClick();
  }, [props.textMessage]);
  const [overLay, setOverLay] = useState(false);

  // console.log(textOnClick,"TExtOnClick")
  let data;

  data =
    currentData &&
    currentData.map((item, index) => {
      return (
        <div style={{ width: "100%" }} >
          {(index === 0 && textOnClick !== undefined) || textOnClick === "" ? (
            <div className="onclick-openwrapp section0 userchatmsg0_1 userchatmsg">
              <div
                className="onclick-inner"
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                {" "}
                <span className="packs-img">
                  {JSON.parse(localStorage.getItem("userName")) !==
                  "Testing" ? (
                    JSON.parse(localStorage.getItem("userName"))
                      ?.match(/\b(\w)/g)
                      .join("")
                  ) : (
                    <img height="15" width="15" src={userIcon}></img>
                  )}
                </span>{" "}
                <span className="packs-text">{textOnClick}</span>{" "}
              </div>
              <div>
                <div className="delivery-time-first">
                  {timeCurrent}
                  <span>
                    <img src={deliveryTimeIcon} className="img-fluid" alt="" />
                  </span>
                </div>
              </div>
            </div>
          ) : null}
          {/* {item.uiCommand  === 'A41' && <Banner item={item} />}
  {item.uiCommand  === 'A40' && <RechargeToast item={item} />} */}
          {/* here u have to change the code */}

          {item.uiCommand === "A1" && (
            <MessageA1
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A3" && <MessageA3 item={item} index={index} />}
          {item.uiCommand === "A2" && (
            <MessageA2
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A6" && <MessageA6 item={item} />}
          {item.uiCommand === "A7" && (
            <MessageA7 item={item} setTextOnClick={setTextOnClick} />
          )}
          {item.uiCommand === "Redirect" && (
            <MessageRedirect
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A39" && <MessageA39 item={item} />}
          {item.uiCommand === "A14" && <MessageA14 item={item} />}
          {item.uiCommand === "A17" && <MessageA17 item={item} />}
          {item.uiCommand === "A5" && <MessageA5 item={item} />}
          {item.uiCommand === "A13" && <MessageA13 item={item} />}
          {item.uiCommand === "A15" && (
            <MessageA15
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A19" && <MessageA19 item={item} />}
          {item.uiCommand === "A21" && (
            <MessageA21
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A22" && <MessageA22 item={item} />}
          {item.uiCommand === "A23" && (
            <MessageA23
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A24" && <MessageA24 item={item} />}
          {item.uiCommand === "A42" && (
            <MessageA42 item={item} setTextOnClick={setTextOnClick} />
          )}
          {item.uiCommand === "A48" && (
            <MessageA48
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {item.uiCommand === "A58" && (
            <MessageA58
              item={item}
              handleClick={handleClick}
              tag={item.uiCommand}
              enableDontSend={() => {
                props.handleDontSend();
              }}
            />
          )}
          {item.uiCommand === "A59" && (
            <MessageA59
              item={item}
              handleClick={handleClick}
              tag={item.uiCommand}
            />
          )}
          {item.uiCommand === "A60" && (
            <MessageA60
              item={item}
              handleClick={handleClick}
              tag={item.uiCommand}
            />
          )}
          {item.uiCommand === "A61" && (
            <MessageA61
              item={item}
              handleClick={handleClick}
              tag={item.uiCommand}
            />
          )}
          {item.uiCommand === "A62" && (
            <MessageA62
              item={item}
              handleClick={handleClick}
              tag={item.uiCommand}
            />
          )}
          {item.uiCommand === "A80" && (
            <MessageA80
              item={item}
              handleClick={handleClick}
              tag={item.uiCommand}
            />
          )}
          {/* { index === currentData.length - 1 && <div ><br /><div className="delivery-time"></div></div>}
    
      { index === currentData.length-1 && <div ><br/>  <div className="delivery-time-first" >{timeCurrent}<span><img src={deliveryTimeIcon} className="img-fluid" alt="" /></span></div>
</div>} */}
        </div>
      );
    });

  useEffect(() => {
    if (data) setMessages([...messages, data]);
    // console.log("to view", data);
    // console.log("messagesuse", messages.flat())
    // const messageData = { text:props.textMessage,uiCommand:"A3" }
    //  let dataItem = [...messages, messageData];
    // setCurrentData(dataItem);
    // currentData.push(props.textMessage)
  }, [currentData]);

  return (
    <Fragment>
      {props.thirdOkay && (
        <div className="chat-box-wrapper">
          <div class="coach-screen-inner">
            {/* {(!localStorage.getItem('redirectLinkFullScreen')) && <div class="circle">
					<div class="text-wrapp visible">
						<p>Add your query in the below box</p>
						<a href="#" class="btn btn-primary mT10 nextbtn waves-effect waves-light" onClick={()=>props.handleThirdOkay()}>Okay</a>
					</div>
				</div>} */}
          </div>
        </div>
      )}
      {props.loginLoader ? (
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      ) : (
        <>
          {showRecharge && (
            <RechargeToast
              item={rechargeData}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {showBanner && (
            <Banner
              item={bannerData}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {/* <div className="chat-wrapp flex-between" style={{ display: 'flex',marginBottom:'5%'}}>
          <div className="chat-person">
            <img src={chatPerson} alt="" /> </div>
          <div className="chat-text" style={{ marginLeft: '10px' }}  > Hi {props.name}, how can I help you?<br />
                                    Pick a topic to start our chat. </div>
        </div> */}

          {initialLoading && !props.historyLoader && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
          {showHistory && props.sth && (
            <>
              {" "}
              {props.historyLoader ? (
                <div class="spinner">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              ) : (
                <div> {historyData}</div>
              )}
            </>
          )}

          {messages}
          {/* {textMessage && <MessageA7 textMessage={textMessage}></MessageA7>} */}

          {props.isLoading && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
        </>
      )}
      <div ref={messagesEndRef} />
    </Fragment>
  );
};

export default Conversation;
